import React from 'react'
import { Box, IconButton } from '@mui/material'
import Navigation from 'components/Navigation'
import MenuIcon from '@mui/icons-material/Menu'

interface Props {
  children: React.ReactNode
}

const Layout: React.FC<Props> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <Navigation
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          background: '#1D2634',
          maxWidth: {
            xs: '100vw',
            sm: 'calc(100vw - 256px)',
          },
          minHeight: '100vh',
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        {children}
      </Box>
    </Box>
  )
}

export default Layout
